export default __webpack_public_path__ + "static/media/promotion2.92dc3860.svg";